import React from "react";
import "./Professional.css";
import MenuNavbar from '../function-components/MenuNavbar';
import Floaticons from '../function-components/Floaticons';

function Professional() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <Floaticons />
            <div className="professional-container">
                
                <p className="click-here-link">
                    <a href="https://atci.lkm.delivery.accenture.com/ProfessionalSkills/" target="_blank">Click here</a> for more details on Professional Skills
                </p>
            </div>
        </>
    );
}

export default Professional;
